<mat-card>
    <mat-card-title class="font-weight-bold caption-color">Ops Part Search</mat-card-title>
    <mat-divider></mat-divider>
    <mat-card-content class="pt-2">


        <div class="row">
            <div class="col-sm-4">
                <div class="form-group row text-left">
                  <label for="lblSegment`" class="col-sm-4 col-form-label">Segment
                    <span class="font-red-flamingo">*</span></label>
                  <div class="col-sm-8">
                    <select id="ddlProductCategory"  name="ddlProductCategory"  class="form-control"  [(ngModel)]="ProductSearchParam.ProdSegmentId"
                    (ngModelChange)="ChangeProductSegment()">
                      <option *ngFor="let pc of ProductSegmentList"  value={{pc.prodSegmentId}}>{{pc.prodSegmentDesc}} </option>
                    </select>
                  </div>
                  
                </div>                
              </div>
            
              <div class="col-sm-4">
                <div class="form-group row text-left">
                  <label for="lblSegment`" class="col-sm-4 col-form-label">Grade
                    <span class="font-red-flamingo">*</span></label>
                  <div class="col-sm-8">
                    <select id="ddlProductGrade"  name="ddlProductGrade"  class="form-control"  [(ngModel)]="GradeId" 
                    (ngModelChange)="ChangeProductGrade()" >
                      <option *ngFor="let pc of ProductGradeList"  value={{pc.qaId}}>{{pc.qaDesc}} </option>
                    </select>
                  </div>
                  
                </div>                
              </div>

              <div class="col-sm-4" *ngIf="!IsRental">
                <div class="form-group row text-left">
                  <label for="lblPoRefNo" class="col-sm-4 col-form-label">Group
                    <span class="font-red-flamingo">*</span></label>
                  <div class="col-sm-8">
                    <mat-radio-group aria-label="Select Group" (ngModelChange)="ChangeProductSegment()" [(ngModel)]="AdvanceGroupId">
                        <mat-radio-button value="1" class="pr-2">All Except Spare</mat-radio-button>
                        <mat-radio-button value="2">Spares</mat-radio-button>
                      </mat-radio-group>
                      
                  </div>
                  
                </div>                
              </div>
            </div>
        <table class="table">
            <thead>
                <tr>
                    <th>Prod Code</th>
                    <th>Description</th>
                   
                     <th>Group</th> 
                       <!-- commented by rahul yadav on 12/07/2021 to remove grade from product row -->
                    <!-- <th>Grade</th> -->
                    <th>Stock</th>
                    <th>Quantity</th>
                    <th *ngIf="!IsRental">Price</th>
                    <th *ngIf="!IsRental">Total</th>
                    <th *ngIf="IsTaxApplicable">Tax</th>
                    <th *ngIf="IsTaxApplicable">Tot. Incl. Tax</th>
                    <th *ngIf="ProfitTag && !IsRental">Price-List</th>
                    <th *ngIf="ProfitTag && !IsRental">Worksheet-Net Sales Price</th>
                    <th *ngIf="ProfitTag && !IsRental">LC-Worksheet</th>
                    <th *ngIf="ProfitTag && !IsRental">Book LC</th> 

                    <th *ngIf="ProfitTag && IsRental">Total Unit Sale Price</th>
                    <th *ngIf="ProfitTag && IsRental">Total Sales Amount</th>
                    <!-- <th *ngIf="ProfitTag && IsRental">Unit Cost(WorkSheet Price)</th> -->
                    <th *ngIf="ProfitTag && IsRental">LC-Worksheet</th>
                    <th *ngIf="ProfitTag && IsRental">Cost Amount</th>

                    <th  class="PL-2 text-right">Action</th>


                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of productArray; let i = index;">
                    <td>
                        <!-- <input [(ngModel)]="item.Id" class="form-control" type="text" />     -->
                      <div>
                        <!-- [clearable]="true" -->
                        <!-- (ngModelChange)="ProductModelChange(item)" -->
                        <!--Removed (clear)='onClear(item)' by Sagar Pandey and added Hide-icon class to hide clear icon-->
                        <ng-select bindLabel="name" placeholder="Select item" [multiple]="false" name="sctProduct" class="ngSelect250 hide-clear-icon"
                            [searchable]="true" (keyup)="onProductCodeKeypress($event,item,i)" [(ngModel)]="item.SelectedProduct" 
                            (ngModelChange)="ProductModelChange(item,i)" >
                            <ng-option [value]="p"  *ngFor="let p of ProductCodes">                                
                                {{p?.productCode}}
                            </ng-option>
                        </ng-select>
                    </div>
                    </td>
                    <td>
                        <label>{{item.SelectedProduct?.productDesc}}</label>
                    </td>
                    <td>
                        <label>{{item.SelectedProduct?.productGroupDesc}}</label>
                    </td>
                <!-- commented by rahul yadav on 12/07/2021 to remove grade from product row -->
                    <!-- <td>
                        <label>{{item.SelectedProduct?.grade}}</label>
                    </td> -->
                    <td>
                        <label>{{item.SelectedProduct?.stock}}</label>
                    </td>
                    <td>
                        <input type="number" name="txtQuantity" [(ngModel)]="item.Quantity" 
                         class="form-control mw-100" (input)="CalculateTotalValue()">
                    </td>
                    <td *ngIf="!IsRental">
                        <input type="number" name="txtPrice" [(ngModel)]="item.Price"  
                         class="form-control mw-100" (change)="CalculateTotalValue()">
                    </td>
                    <td *ngIf="!IsRental" class="text-right">
                        <label>{{item.Price*item.Quantity}}</label>
                    </td>
                    <td *ngIf="IsTaxApplicable" class="text-right">                        
                        <div class="tooltipCustom">{{item.SelectedProduct?.taxValue}}
                            <div class="tooltiptextCustom" [innerHtml]="item.SelectedProduct?.taxHtml"></div>
                          </div>
                    </td>
                    <td *ngIf="IsTaxApplicable" class="text-right">
                        
                        <label>{{(item.Price*item.Quantity)+item.SelectedProduct?.taxValue}}</label>
                    </td>

                    <td *ngIf="ProfitTag && !IsRental" class="text-right">
                        <label>{{item.PriceList}}</label>
                    </td>
                    <td *ngIf="ProfitTag && !IsRental" class="text-right">
                        <label>{{item.WorkSheetNSP}}</label>
                    </td>
                    <td *ngIf="ProfitTag && !IsRental" class="text-right">
                        <label>{{item.WorkSheetLanded}}</label>
                    </td>
                    <td *ngIf="ProfitTag && !IsRental" class="text-right">
                        <label>{{item.BookingLanded}}</label>
                    </td>

                    <td *ngIf="ProfitTag && IsRental" class="text-right">
                        <label class="pr-2">{{item.UnitSalePrice | number : '1.2-2'}}</label>
                    </td>
                    <td *ngIf="ProfitTag && IsRental" class="text-right">
                        <label class="pr-2">{{item.SaleAmount | number : '1.2-2'}}</label>
                    </td>



                      <td *ngIf="ProfitTag && IsRental" class="text-right">
                        <label  class="pr-2">{{item.UnitWSCost | number : '1.2-2'}}</label>
                    </td>
                    <td *ngIf="ProfitTag && IsRental" class="text-right">
                        <label  class="pr-2">{{item.CostAmount | number : '1.2-2'}}</label>
                    </td>
                  

                    <td *ngIf="item.IsNewRow" class="text-right" (click)="deleteRow(i)">
                        <i class="fa fa-trash fa-2x"></i>
                    </td>
                    <td *ngIf="!item.IsNewRow" class="text-right"(click)="addRow(item)">
                        <i class="fa fa-plus fa-2x"></i>
                    </td>
                  
                </tr>
                <tr *ngIf="ProfitTag && IsRental" class="bg-highlight">
                    <td>
                      Total
                    </td>
                    <td>
                        
                    </td>
                    <td>
                        
                       
                    </td>
                    <td>
                      
                    </td>
                    <td>
                       
                    </td>                   
                    

                    <td *ngIf="ProfitTag" class="text-right">
                        <label></label>
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label class="pr-2">{{ProductProfitablity.TotLoanAmount | number : '1.0-0'}}</label> 
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label></label> 
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label class="pr-2">{{ProductProfitablity.TotCostAmount | number : '1.0-0'}}</label> 
                    </td>
                    <td *ngIf="ProfitTag"></td>

                </tr>
                <tr *ngIf="ProfitTag && IsRental" class="bg-highlight">
                    <td>
                      Total Discount
                    </td>
                    <td>
                   
                        
                    </td>
                    <td>
                       
                    </td>
                    <td>
                      
                    </td>
                    <td>
                       
                    </td>                   
                    

                    <td *ngIf="ProfitTag" class="text-right">
                        <label></label>
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label class="pr-2">{{ProductProfitablity.TotDiscount | number : '1.0-0'}}</label> 
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label></label> 
                    </td>
                    <td *ngIf="ProfitTag">
                        
                    </td>
                    <td *ngIf="ProfitTag"></td>

                </tr>
                <tr *ngIf="ProfitTag && IsRental" class="bg-highlight">
                    <td colspan="3">
                        Net Sales Value (Order Logging Value)
                    </td>
                 
                    <td>
                       
                    
                      
                    </td>
                    <td>
                       
                    </td>                   
                    

                    <td *ngIf="ProfitTag" class="text-right">
                        <label></label>
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label class="pr-2">{{ProductProfitablity.TotLoanAmount - ProductProfitablity.TotDiscount | number : '1.0-0'}}</label> 
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label class="pr-2"><b>GP</b></label> 
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label class="pr-2"><b>{{(((ProductProfitablity.TotLoanAmount - ProductProfitablity.TotDiscount) -ProductProfitablity.TotCostAmount)/(ProductProfitablity.TotLoanAmount - ProductProfitablity.TotDiscount))*100 | number : '1.2-2'}}%</b></label> 
                    </td>
                    <td *ngIf="ProfitTag"></td>

                </tr>
                <tr *ngIf="ProfitTag && IsRental" class="bg-highlight">
                    <td colspan="2">
                    <b> Profit Without Interest</b> 
                    </td>
                 
                    <td>
                       
                                          
                    </td>
                    <td>
                      
                    </td>
                    <td>
                       
                    </td>                   
                    

                    <td *ngIf="ProfitTag">
                        <label></label>
                    </td>
                    <td *ngIf="ProfitTag">
                        
                    </td>
                    <td *ngIf="ProfitTag"  class="text-right">
                        <label class="pr-2"><b>GP</b></label> 
                    </td>
                    <td *ngIf="ProfitTag"  class="text-right">
                        <label class="pr-2"><b>{{ProductProfitablity.ProfitBeforeTax | number : '1.2-2'}}%</b></label> 
                    </td>
                    <td *ngIf="ProfitTag"></td>

                </tr>
                <tr *ngIf="ProfitTag && IsRental" class="bg-highlight">
                    <td colspan="2">
                    <b>Profit With Interest</b>
                    </td>
                 
                    <td>
                    </td>
                    <td>
                      
                    </td>
                    <td>
                       
                    </td>                   
                    

                    <td *ngIf="ProfitTag">
                        <label></label>
                    </td>
                    <td *ngIf="ProfitTag">
                        
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label class="pr-2"><b>GP</b></label> 
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label class="pr-2"><b>{{ProductProfitablity.ProfitBeforeTaxWithInt | number : '1.2-2'}}%</b></label> 
                    </td>
                    <td *ngIf="ProfitTag"></td>

                </tr>

                <tr *ngIf="ProfitTag && !IsRental" class="bg-highlight">
                    <td>
                      <b>Total Discount</b>
                    </td>
                    <td>
                    
                    </td>
                    <td>
                       
                    </td>
                    <td>
                      
                    </td>
                    <td>
                        <label></label>
                    </td>
                    <td>
                        <label></label>
                    </td>
                    <td class="text-right">
                        <label><b>{{ProductProfitablity.TotDiscount  | number : '1.0-0'}}</b></label>
                    </td>
                    <td *ngIf="IsTaxApplicable" class="text-right">
                        
                    </td>
                    <td *ngIf="IsTaxApplicable" class="text-right">
                        
                    </td>

                    <td *ngIf="ProfitTag">
                        
                    </td>
                    <td *ngIf="ProfitTag">
                        
                    </td>
                    <td *ngIf="ProfitTag">
                        
                    </td>
                    <td *ngIf="ProfitTag">
                      
                    </td>
                    <td *ngIf="ProfitTag"></td>

                </tr>
                <tr *ngIf="ProfitTag && !IsRental" class="bg-highlight">
                    <td>
                      <b> Net Sale Price Released</b>
                    </td>
                    <td>
                        
                    </td>
                    <td>
                       
                    </td>
                    <td>
                      
                    </td>
                    <td>
                        <label><b>{{ProductProfitablity.TotalQty }}</b></label>
                    </td>
                    <td>
                        <label><b>{{ProductProfitablity.TotalPrice | number : '1.0-0'}}</b></label>
                    </td>
                    <td class="text-right">
                        <label><b>{{ProductProfitablity.TotalSaleValue | number : '1.0-0'}}</b></label>
                    </td>
                    <td *ngIf="IsTaxApplicable" class="text-right">
                        
                    </td>
                    <td *ngIf="IsTaxApplicable"  class="text-right">
                        
                    </td>

                    <td *ngIf="ProfitTag" class="text-right">
                        <label><b>{{ProductProfitablity.TotalPriceList | number : '1.0-0'}}</b></label>
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label><b>{{ProductProfitablity.TotalWSNSP | number : '1.0-0'}}</b></label> 
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label><b>{{ProductProfitablity.TotalLandedCost | number : '1.0-0'}}</b></label> 
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label><b>{{ProductProfitablity.TotalBookLC | number : '1.0-0'}}</b></label> 
                    </td>
                    <td *ngIf="ProfitTag"></td>

                </tr>
              
                <tr *ngIf="ProfitTag && !IsRental" class="bg-highlight">
                    <td colspan="2"> 
                    <b>FG GP(%) BEING REALISED AGAINST THIS ORDER :</b>
                    </td>
                    <td>
                       
                    </td>
                    <td>
                      
                    </td>
                    <td>
                        
                    </td>
                    <td>
                        
                    </td>
                    <td>
                       
                    </td>
                    <td *ngIf="IsTaxApplicable" class="text-right">
                        
                    </td>
                    <td *ngIf="IsTaxApplicable" class="text-right">
                        
                    </td>

                    <td *ngIf="ProfitTag" class="text-right">
                        <label><b>{{ProductProfitablity.GPPriceList}}</b></label>
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label><b>{{ProductProfitablity.GPWSNSP}}</b></label> 
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label><b>{{ProductProfitablity.GPLandedCost}}</b></label> 
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label><b>{{ProductProfitablity.GPBookLC}}</b></label> 
                    </td>
                    <td *ngIf="ProfitTag"></td>

                </tr>

                <tr *ngIf="ProfitTag && !IsRental" class="bg-highlight">
                    <td>
                    <b>FG + Serv Net Sale Price Released</b>
                    </td>
                    <td>                        
                    </td>
                    <td>                       
                    </td>
                    <td>                      
                    </td>
                    <td>                       
                    </td>
                    <td>                       
                    </td>
                    <td class="text-right"> 
                        <label><b>{{ProductProfitablity.TotalFGServSaleValue | number : '1.0-0'}}</b></label>                      
                    </td>
                    <td *ngIf="IsTaxApplicable">                        
                    </td>
                    <td *ngIf="IsTaxApplicable">                        
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label><b>{{ProductProfitablity.TotalFGServPriceList | number : '1.0-0'}}</b></label>
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label><b>{{ProductProfitablity.TotalFGServWSNSP | number : '1.0-0'}}</b></label> 
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label><b>{{ProductProfitablity.TotalFGServLandedCost | number : '1.0-0'}}</b></label> 
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label><b>{{ProductProfitablity.TotalFGServBookLC | number : '1.0-0'}}</b></label> 
                    </td>
                    <td *ngIf="ProfitTag"></td>

                </tr>
                <tr *ngIf="ProfitTag && !IsRental" class="bg-highlight">
                    <td colspan="2"> 
                    <b>Total GP(%) BEING REALISED AGAINST THIS ORDER :</b>
                    </td>
                    <td>
                       
                    </td>
                    <td>
                      
                    </td>
                    <td>
                        
                    </td>
                    <td>
                        
                    </td>
                    <td>
                       
                    </td>
                    <td *ngIf="IsTaxApplicable">
                        
                    </td>
                    <td *ngIf="IsTaxApplicable">
                        
                    </td>

                    <td *ngIf="ProfitTag" class="text-right">
                        <label><b>{{ProductProfitablity.FGServGPPriceList}}</b></label>
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label><b>{{ProductProfitablity.FGServGPWSNSP}}</b></label> 
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label><b>{{ProductProfitablity.FGServGPLandedCost}}</b></label> 
                    </td>
                    <td *ngIf="ProfitTag" class="text-right">
                        <label><b>{{ProductProfitablity.FGServGPBookLC}}</b></label> 
                    </td>
                    <td *ngIf="ProfitTag"></td>

                </tr>
            </tbody>
        </table>


        <div class="row">
            <div class="col-sm-12">
                <div class="form-group row text-left">
                    <h4 class="col-sm-12">
                        <span class="badge badge-pill badge-primary"  (click)="OpenConsignee()" >Enter Consignee Address Detail</span>
                    </h4>
        
        </div>
            </div>
        </div>

    </mat-card-content>
</mat-card>